import React from 'react';
import { useNavigationLink } from '../hooks/useNavigationLink';
import { useGetUserData } from '../hooks/useGetUserData';
import { useRequireLogin } from '../hooks/useRequireLogin';
import { useSetZipCode } from '../hooks/useSetZipCode';
import { useGetCart } from '../hooks/useGetCart';
import { useGetZipCode } from '../hooks/useGetZipCode';
import { useUserLocation } from '../hooks/useUserLocation';
import { useDeviceInfo } from '../hooks/useDeviceInfo';
import defaultContext from './defaultContextValue';
export var PlatformContext = React.createContext(defaultContext);
export var Provider = PlatformContext.Provider, Consumer = PlatformContext.Consumer;
export var PlatformHooksProvider = function (_a) {
    var children = _a.children, config = _a.config, _b = _a.logger, logger = _b === void 0 ? console : _b;
    var configValue = config || {};
    var useGetUserDataHook = useGetUserData(config, logger);
    var useRequireLoginHook = useRequireLogin(config, logger);
    var useGetCartHook = useGetCart(config, logger);
    var useSetZipCodeHook = useSetZipCode(config, logger);
    var useGetZipCodeHook = useGetZipCode(config, logger);
    var useUserLocationHook = useUserLocation(config, logger);
    var useDeviceInfoHook = useDeviceInfo(config, logger);
    var useNavigationLinkHook = useNavigationLink(config, logger);
    return (React.createElement(Provider, { value: {
            config: configValue,
            useGetUserData: useGetUserDataHook,
            useRequireLogin: useRequireLoginHook,
            useGetCart: useGetCartHook,
            zipCode: {
                useSetZipCode: useSetZipCodeHook,
                useGetZipCode: useGetZipCodeHook,
            },
            useUserLocation: useUserLocationHook,
            useDeviceInfo: useDeviceInfoHook,
            useNavigationLink: useNavigationLinkHook,
        } }, children));
};
